export default "__VITE_ASSET__D0ZR_8SN__"